import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Enroll learner',
  subtitle:
    'Choose from available workspace learners to enroll them in this course',
  DateHeading: 'Course completion date',
  DatePlaceholder: '(Optional)',
  cantFindLearners: 'No results found',
  invite: 'Invite',
  enroll: 'Enroll selected',
  courseNotPublished: 'To enroll learners you need to publish this course',
  dueDateModalTitle: 'Confirm or skip the due date',
  skipAndEnroll: 'Skip & enroll',
  saveAndEnroll: 'Save & enroll',
  dueDate: 'Due date',
  dueDatePlaceholder: 'Select a due date',
  viewEnrolledLearners: 'View enrolled learners',
  addLearnersTab: 'Add learners +',
  enrolledLearnersTab: 'Enrolled',
  removeSelected: 'Remove selected',
  emptyEnrolledTitle: 'No one is enrolled yet',
  emptyEnrolledText:
    'Add learners from the other tab and they will see this course in their feed.',
};

const welsh = {
  title: 'Cofrestru dysgwr',
  subtitle:
    "Dewiswch o ddysgwyr gweithle sydd ar gael i'w cofrestru yn y cwrs hwn",
  DateHeading: 'Dyddiad gorffen y cwrs',
  DatePlaceholder: '(Dewisol)',
  cantFindLearners: "Dim canlyniad wedi'i ganfod",
  invite: 'Gwahodd',
  enroll: "Cofrestru'r rhai a ddewiswyd",
  courseNotPublished:
    "I gofrestru dysgwyr, mae angen i chi gyhoeddi'r cwrs hwn",
  dueDateModalTitle: 'Cadarnhewch neu sgipiwch y dyddiad gorffen',
  skipAndEnroll: 'Sgipio a chofrestru',
  saveAndEnroll: 'Cadw a chofrestru',
  dueDate: 'Dyddiad gorffen',
  dueDatePlaceholder: 'Dewiswch ddyddiad gorffen',
  viewEnrolledLearners: 'Gweld dysgwyr cofrestredig',
  addLearnersTab: 'Ychwanegu dysgwyr',
  enrolledLearnersTab: 'Cofrestredig',
  removeSelected: "Tynnu'r rhai a ddewiswyd",
  emptyEnrolledTitle: 'Does neb wedi cofrestru eto',
  emptyEnrolledText:
    "Ychwanegwch ddysgwyr o'r tab arall a byddant yn gweld y cwrs hwn yn eu ffrwd.",
};

export const courseLearnerText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
